import { useState, type FormEvent } from 'react';

interface BookingModalProps {
  open: boolean;
  serviceName: string;
  onClose: () => void;
}

export default function BookingModal({ open, serviceName, onClose }: BookingModalProps) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [date, setDate] = useState('');
  const [note, setNote] = useState('');
  const [toast, setToast] = useState('');
  const [error, setError] = useState('');

  if (!open) return null;

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !phone.trim()) {
      setError('请填写姓名与联系电话');
      return;
    }
    setError('');
    setToast('预约信息已提交（仅模拟演示，不会真实处理）');
    setName('');
    setPhone('');
    setDate('');
    setNote('');
    window.setTimeout(() => {
      setToast('');
      onClose();
    }, 2200);
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-secondary-950/60 px-4">
      <div className="w-full max-w-md rounded-xl border border-background-200 bg-background-50 p-6">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">预约与咨询</h3>
            <p className="mt-1 text-xs text-secondary-500">{serviceName}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 items-center justify-center rounded-md text-secondary-500 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        {toast ? (
          <div className="mt-6 flex flex-col items-center py-8 text-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-checkbox-circle-line text-3xl"></i>
            </span>
            <p className="mt-4 text-sm text-foreground-800">{toast}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-5 space-y-4">
            <div>
              <label className="mb-1.5 block text-xs text-secondary-600">
                姓名 <span className="text-accent-600">*</span>
              </label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                type="text"
                placeholder="请输入您的姓名"
                className="h-10 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-900 outline-none focus:border-primary-400"
              />
            </div>
            <div>
              <label className="mb-1.5 block text-xs text-secondary-600">
                联系电话 <span className="text-accent-600">*</span>
              </label>
              <input
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                type="tel"
                placeholder="请输入联系电话"
                className="h-10 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-900 outline-none focus:border-primary-400"
              />
            </div>
            <div>
              <label className="mb-1.5 block text-xs text-secondary-600">期望上门时间</label>
              <input
                value={date}
                onChange={(e) => setDate(e.target.value)}
                type="date"
                className="h-10 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-900 outline-none focus:border-primary-400"
              />
            </div>
            <div>
              <label className="mb-1.5 block text-xs text-secondary-600">备注说明</label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value.slice(0, 500))}
                maxLength={500}
                rows={3}
                placeholder="可补充地址、房屋面积或特殊需求"
                className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-900 outline-none focus:border-primary-400"
              />
              <div className="mt-1 text-right text-[11px] text-secondary-400">{note.length}/500</div>
            </div>

            {error && (
              <p className="flex items-center gap-1.5 text-xs text-accent-700">
                <i className="ri-error-warning-line"></i>
                {error}
              </p>
            )}

            <p className="rounded-md bg-secondary-100 px-3 py-2 text-[11px] leading-relaxed text-secondary-600">
              温馨提示:本预约表单仅用于功能演示,提交后不会产生真实订单或数据处理。
            </p>

            <button
              type="submit"
              className="flex h-11 w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-calendar-check-line"></i>
              提交预约（演示）
            </button>
          </form>
        )}
      </div>
    </div>
  );
}